import { LogOut } from "lucide-react";

import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem
} from "@/components/ui/sidebar";
import useAuthStore from "@/store/auth";
import { useNavigate } from "@tanstack/react-router";

import type { SidebarItem } from "./app-sidebar";

import { AppSwitcher } from "./app-switcher";

export function NavSecondary({
	items,
	...props
}: {
	items: SidebarItem[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
	const navigate = useNavigate();
	const logOut = useAuthStore(state => state.logout);

	const handleLogOut = () => {
		navigate({ to: "/discovery" }).then(() => {
			logOut();
		});
	};

	return (
		<SidebarGroup {...props}>
			<SidebarGroupContent>
				<SidebarMenu>
					<SidebarMenuItem>
						<AppSwitcher />
					</SidebarMenuItem>
					<SidebarMenuButton onClick={handleLogOut} size="sm">
						<LogOut />
						<span className="text-base font-thin">Log out</span>
					</SidebarMenuButton>
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
